export const algebra2TestVA = [
  {
    id: 1,
    question: "Divide: (6 + 8i) / (2i)",
    options: [
      "4 - 3i",
      "4 + 3i",
      "-4 + 3i",
      "3 + 4i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Multiply numerator and denominator by the conjugate of the denominator.\nThe conjugate of 2i is -2i.\n\nStep 2: Multiply:\n(6 + 8i) / (2i) · (-2i) / (-2i)\n= (6 + 8i)(-2i) / (2i)(-2i)\n\nStep 3: Expand numerator:\n(6)(-2i) + (8i)(-2i) = -12i - 16i²\n= -12i - 16(-1) = -12i + 16 = 16 - 12i\n\nStep 4: Expand denominator:\n(2i)(-2i) = -4i² = -4(-1) = 4\n\nStep 5: Simplify:\n(16 - 12i) / 4 = 16/4 - 12i/4 = 4 - 3i\n\nAnswer: A",
    points: 2
  },
  {
    id: 2,
    question: "What is the determinant of the matrix [[3, 5], [2, 4]]?",
    options: [
      "2",
      "12",
      "22",
      "-2"
    ],
    correctAnswer: 0,
    solution: "Step 1: For a 2×2 matrix [[a, b], [c, d]], the determinant is:\ndet = ad - bc\n\nStep 2: Identify the elements:\na = 3, b = 5, c = 2, d = 4\n\nStep 3: Calculate:\ndet = (3)(4) - (5)(2)\n    = 12 - 10\n    = 2\n\nAnswer: A",
    points: 2
  },
  {
    id: 3,
    question: "Solve: 2^(3x) = 16",
    options: [
      "x = 4/3",
      "x = 4",
      "x = 3",
      "x = 16/3"
    ],
    correctAnswer: 0,
    solution: "Step 1: Express 16 as a power of 2:\n16 = 2⁴\n\nStep 2: Rewrite the equation:\n2^(3x) = 2⁴\n\nStep 3: Since bases are equal, set exponents equal:\n3x = 4\n\nStep 4: Solve for x:\nx = 4/3\n\nStep 5: Check: 2^(3·4/3) = 2⁴ = 16 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 4,
    question: "What is the mean of the data set: 12, 15, 18, 20, 25?",
    options: [
      "18",
      "17",
      "19",
      "20"
    ],
    correctAnswer: 0,
    solution: "Step 1: Add all values:\n12 + 15 + 18 + 20 + 25 = 90\n\nStep 2: Count the number of values:\nn = 5\n\nStep 3: Calculate the mean:\nMean = Sum / n = 90 / 5 = 18\n\nAnswer: A",
    points: 2
  },
  {
    id: 5,
    question: "Simplify: (x³y⁴)²",
    options: [
      "x⁶y⁸",
      "x⁵y⁶",
      "x⁶y⁶",
      "x⁹y¹⁶"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the power rule: (x^m)^n = x^(mn)\n\nStep 2: Apply to each variable:\n(x³)² = x^(3·2) = x⁶\n(y⁴)² = y^(4·2) = y⁸\n\nStep 3: Combine:\n(x³y⁴)² = x⁶y⁸\n\nAnswer: A",
    points: 2
  },
  {
    id: 6,
    question: "What is the standard deviation of the data set: 2, 4, 6, 8, 10? (Round to nearest tenth)",
    options: [
      "2.8",
      "3.2",
      "2.0",
      "4.0"
    ],
    correctAnswer: 0,
    solution: "Step 1: Find the mean:\nMean = (2 + 4 + 6 + 8 + 10) / 5 = 30 / 5 = 6\n\nStep 2: Find squared deviations from mean:\n(2-6)² = 16\n(4-6)² = 4\n(6-6)² = 0\n(8-6)² = 4\n(10-6)² = 16\n\nStep 3: Find variance (average of squared deviations):\nVariance = (16 + 4 + 0 + 4 + 16) / 5 = 40 / 5 = 8\n\nStep 4: Standard deviation = √variance:\nSD = √8 ≈ 2.828 ≈ 2.8\n\nAnswer: A",
    points: 2
  },
  {
    id: 7,
    question: "Multiply the matrices: [[2, 3]] · [[1], [4]]",
    options: [
      "14",
      "[[2, 12]]",
      "[[2], [12]]",
      "Cannot multiply"
    ],
    correctAnswer: 0,
    solution: "Step 1: Check dimensions:\nFirst matrix: 1×2\nSecond matrix: 2×1\nResult will be: 1×1 (a single number)\n\nStep 2: Multiply:\n[2, 3] · [[1], [4]] = 2(1) + 3(4)\n\nStep 3: Calculate:\n= 2 + 12 = 14\n\nStep 4: Result is the scalar 14 (or [[14]] as a 1×1 matrix)\n\nAnswer: A",
    points: 2
  },
  {
    id: 8,
    question: "Solve: log(x) + log(5) = log(30)",
    options: [
      "x = 6",
      "x = 25",
      "x = 150",
      "x = 35"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the logarithm product rule:\nlog(a) + log(b) = log(ab)\n\nStep 2: Apply to left side:\nlog(x) + log(5) = log(5x)\n\nStep 3: Set equal to right side:\nlog(5x) = log(30)\n\nStep 4: Since logarithms are equal:\n5x = 30\n\nStep 5: Solve for x:\nx = 30/5 = 6\n\nStep 6: Check: log(6) + log(5) = log(30) ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 9,
    question: "What is the inverse of the matrix [[2, 1], [5, 3]]?",
    options: [
      "[[3, -1], [-5, 2]]",
      "[[3, 1], [5, 2]]",
      "[[-3, 1], [5, -2]]",
      "[[2, -1], [-5, 3]]"
    ],
    correctAnswer: 0,
    solution: "Step 1: For matrix [[a, b], [c, d]], the inverse is:\n(1/det) · [[d, -b], [-c, a]]\n\nStep 2: Calculate determinant:\ndet = ad - bc = (2)(3) - (1)(5) = 6 - 5 = 1\n\nStep 3: Swap and negate:\n[[d, -b], [-c, a]] = [[3, -1], [-5, 2]]\n\nStep 4: Multiply by 1/det = 1/1 = 1:\nInverse = [[3, -1], [-5, 2]]\n\nStep 5: Verify by multiplication:\n[[2, 1], [5, 3]] · [[3, -1], [-5, 2]] = [[1, 0], [0, 1]] ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 10,
    question: "Factor: x³ - 64",
    options: [
      "(x - 4)(x² + 4x + 16)",
      "(x - 4)(x² - 4x + 16)",
      "(x + 4)(x² - 4x + 16)",
      "(x - 4)³"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recognize as difference of cubes:\nx³ - 64 = x³ - 4³\n\nStep 2: Apply the formula:\na³ - b³ = (a - b)(a² + ab + b²)\n\nStep 3: Identify a and b:\na = x, b = 4\n\nStep 4: Factor:\n(x - 4)(x² + x·4 + 4²)\n= (x - 4)(x² + 4x + 16)\n\nStep 5: Verify by expanding:\n(x - 4)(x² + 4x + 16)\n= x³ + 4x² + 16x - 4x² - 16x - 64\n= x³ - 64 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 11,
    question: "What is the median of: 5, 12, 8, 15, 20, 18, 10?",
    options: [
      "12",
      "10",
      "15",
      "13"
    ],
    correctAnswer: 0,
    solution: "Step 1: Arrange data in order from least to greatest:\n5, 8, 10, 12, 15, 18, 20\n\nStep 2: Count the number of values:\nn = 7 (odd number)\n\nStep 3: Find the middle value:\nMiddle position = (n + 1)/2 = (7 + 1)/2 = 4th position\n\nStep 4: The 4th value is 12\n\nMedian = 12\n\nAnswer: A",
    points: 2
  },
  {
    id: 12,
    question: "Simplify: (5 - 2i) + (3 + 7i)",
    options: [
      "8 + 5i",
      "8 - 5i",
      "2 + 9i",
      "15 + 5i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Add real parts:\n5 + 3 = 8\n\nStep 2: Add imaginary parts:\n-2i + 7i = 5i\n\nStep 3: Combine in standard form a + bi:\n8 + 5i\n\nAnswer: A",
    points: 2
  },
  {
    id: 13,
    question: "Solve the system using matrices:\n2x + y = 7\nx - y = 2",
    options: [
      "x = 3, y = 1",
      "x = 2, y = 3",
      "x = 1, y = 5",
      "x = 4, y = -1"
    ],
    correctAnswer: 0,
    solution: "Step 1: Write in matrix form AX = B:\n[[2, 1], [1, -1]] · [[x], [y]] = [[7], [2]]\n\nStep 2: Add equations to eliminate y:\n(2x + y) + (x - y) = 7 + 2\n3x = 9\nx = 3\n\nStep 3: Substitute x = 3 into second equation:\n3 - y = 2\ny = 1\n\nStep 4: Check in first equation:\n2(3) + 1 = 6 + 1 = 7 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 14,
    question: "What is the range of the data set: 15, 22, 18, 30, 25, 19?",
    options: [
      "15",
      "30",
      "22.5",
      "12"
    ],
    correctAnswer: 0,
    solution: "Step 1: Find the maximum value:\nMax = 30\n\nStep 2: Find the minimum value:\nMin = 15\n\nStep 3: Calculate range:\nRange = Max - Min = 30 - 15 = 15\n\nAnswer: A",
    points: 2
  },
  {
    id: 15,
    question: "Evaluate: log₈(512)",
    options: [
      "3",
      "4",
      "64",
      "2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Rewrite the question:\nlog₈(512) = x means 8^x = 512\n\nStep 2: Express both as powers of 2:\n8 = 2³\n512 = 2⁹\n\nStep 3: Rewrite equation:\n(2³)^x = 2⁹\n2^(3x) = 2⁹\n\nStep 4: Set exponents equal:\n3x = 9\nx = 3\n\nStep 5: Verify: 8³ = 512 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 16,
    question: "Simplify: √(-36) · √(-4)",
    options: [
      "-12",
      "12",
      "12i",
      "-12i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Express each in terms of i:\n√(-36) = √(36 · -1) = 6i\n√(-4) = √(4 · -1) = 2i\n\nStep 2: Multiply:\n6i · 2i = 12i²\n\nStep 3: Remember i² = -1:\n12i² = 12(-1) = -12\n\nNote: √(a) · √(b) = √(ab) only when at least one is non-negative.\n\nAnswer: A",
    points: 2
  },
  {
    id: 17,
    question: "What is the 7th term of the arithmetic sequence: 4, 9, 14, 19, ...?",
    options: [
      "34",
      "39",
      "29",
      "44"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify first term and common difference:\na₁ = 4\nd = 9 - 4 = 5\n\nStep 2: Use the arithmetic sequence formula:\naₙ = a₁ + (n - 1)d\n\nStep 3: Find the 7th term:\na₇ = 4 + (7 - 1)(5)\n   = 4 + 6(5)\n   = 4 + 30\n   = 34\n\nStep 4: Verify by listing:\n4, 9, 14, 19, 24, 29, 34 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 18,
    question: "Add the matrices: [[2, 5], [3, 7]] + [[1, 4], [6, 2]]",
    options: [
      "[[3, 9], [9, 9]]",
      "[[3, 9], [9, 5]]",
      "[[2, 20], [18, 14]]",
      "[[1, 1], [3, -5]]"
    ],
    correctAnswer: 0,
    solution: "Step 1: Add corresponding elements:\nTop left: 2 + 1 = 3\nTop right: 5 + 4 = 9\nBottom left: 3 + 6 = 9\nBottom right: 7 + 2 = 9\n\nStep 2: Write result matrix:\n[[3, 9], [9, 9]]\n\nAnswer: A",
    points: 2
  },
  {
    id: 19,
    question: "Solve: e^(x-1) = e⁴",
    options: [
      "x = 5",
      "x = 4",
      "x = 3",
      "x = e⁴ + 1"
    ],
    correctAnswer: 0,
    solution: "Step 1: Since bases are equal:\ne^(x-1) = e⁴\n\nStep 2: Set exponents equal:\nx - 1 = 4\n\nStep 3: Solve for x:\nx = 4 + 1 = 5\n\nStep 4: Check: e^(5-1) = e⁴ ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 20,
    question: "What is the mode of: 3, 7, 5, 7, 9, 7, 12, 5?",
    options: [
      "7",
      "5",
      "3",
      "No mode"
    ],
    correctAnswer: 0,
    solution: "Step 1: Count frequency of each value:\n3 appears 1 time\n5 appears 2 times\n7 appears 3 times\n9 appears 1 time\n12 appears 1 time\n\nStep 2: Identify the most frequent value:\n7 appears most often (3 times)\n\nStep 3: Mode = 7\n\nAnswer: A",
    points: 2
  },
  {
    id: 21,
    question: "Simplify: (4i)²",
    options: [
      "-16",
      "16",
      "16i",
      "-16i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Expand the power:\n(4i)² = 4² · i²\n\nStep 2: Evaluate each part:\n4² = 16\ni² = -1\n\nStep 3: Multiply:\n16 · (-1) = -16\n\nAnswer: A",
    points: 2
  },
  {
    id: 22,
    question: "What is the first quartile (Q1) of: 2, 5, 7, 9, 11, 13, 15?",
    options: [
      "5",
      "7",
      "6",
      "2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Data is already ordered:\n2, 5, 7, 9, 11, 13, 15\n\nStep 2: Find the median (Q2):\nMedian = 9 (middle value)\n\nStep 3: Q1 is the median of the lower half:\nLower half: 2, 5, 7\nQ1 = 5 (middle of lower half)\n\nAnswer: A",
    points: 2
  },
  {
    id: 23,
    question: "Solve: 3^(2x-1) = 27",
    options: [
      "x = 2",
      "x = 3",
      "x = 1",
      "x = 4"
    ],
    correctAnswer: 0,
    solution: "Step 1: Express 27 as a power of 3:\n27 = 3³\n\nStep 2: Rewrite equation:\n3^(2x-1) = 3³\n\nStep 3: Set exponents equal:\n2x - 1 = 3\n\nStep 4: Solve for x:\n2x = 4\nx = 2\n\nStep 5: Check: 3^(2·2-1) = 3³ = 27 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 24,
    question: "Multiply: [[2, 3], [1, 4]] · [[1, 0], [0, 1]]",
    options: [
      "[[2, 3], [1, 4]]",
      "[[1, 0], [0, 1]]",
      "[[2, 0], [0, 4]]",
      "[[3, 3], [5, 5]]"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recognize that [[1, 0], [0, 1]] is the identity matrix.\n\nStep 2: Any matrix multiplied by the identity matrix equals itself:\nA · I = A\n\nStep 3: Therefore:\n[[2, 3], [1, 4]] · [[1, 0], [0, 1]] = [[2, 3], [1, 4]]\n\nStep 4: Verify by multiplication:\nTop left: 2(1) + 3(0) = 2\nTop right: 2(0) + 3(1) = 3\nBottom left: 1(1) + 4(0) = 1\nBottom right: 1(0) + 4(1) = 4 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 25,
    question: "What is the variance of: 4, 8, 12, 16, 20?",
    options: [
      "32",
      "40",
      "5.66",
      "8"
    ],
    correctAnswer: 0,
    solution: "Step 1: Find the mean:\nMean = (4 + 8 + 12 + 16 + 20) / 5 = 60 / 5 = 12\n\nStep 2: Find squared deviations:\n(4-12)² = 64\n(8-12)² = 16\n(12-12)² = 0\n(16-12)² = 16\n(20-12)² = 64\n\nStep 3: Calculate variance:\nVariance = (64 + 16 + 0 + 16 + 64) / 5\n         = 160 / 5\n         = 32\n\nAnswer: A",
    points: 2
  },
  {
    id: 26,
    question: "Simplify: log₅(125)",
    options: [
      "3",
      "5",
      "25",
      "15"
    ],
    correctAnswer: 0,
    solution: "Step 1: Rewrite the question:\nlog₅(125) = x means 5^x = 125\n\nStep 2: Express 125 as a power of 5:\n125 = 5³\n\nStep 3: Therefore:\n5^x = 5³\nx = 3\n\nStep 4: Verify: 5³ = 125 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 27,
    question: "What is the conjugate of 7 - 4i?",
    options: [
      "7 + 4i",
      "-7 + 4i",
      "-7 - 4i",
      "4 - 7i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recall the definition of complex conjugate:\nFor a complex number a + bi, the conjugate is a - bi\n(Change the sign of the imaginary part)\n\nStep 2: For 7 - 4i:\nReal part: 7\nImaginary part: -4i\n\nStep 3: Change sign of imaginary part:\nConjugate = 7 + 4i\n\nAnswer: A",
    points: 2
  },
  {
    id: 28,
    question: "Find the sum of the first 6 terms of the geometric sequence: 2, 6, 18, 54, ...",
    options: [
      "728",
      "486",
      "162",
      "1458"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify first term and common ratio:\na₁ = 2\nr = 6/2 = 3\n\nStep 2: Use geometric series sum formula:\nSₙ = a₁(1 - r^n)/(1 - r)\n\nStep 3: Calculate S₆:\nS₆ = 2(1 - 3⁶)/(1 - 3)\n   = 2(1 - 729)/(-2)\n   = 2(-728)/(-2)\n   = -1456/(-2)\n   = 728\n\nStep 4: Verify by adding:\n2 + 6 + 18 + 54 + 162 + 486 = 728 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 29,
    question: "Solve: ln(x + 3) = 2",
    options: [
      "x = e² - 3",
      "x = 2 - 3",
      "x = e² + 3",
      "x = 3e²"
    ],
    correctAnswer: 0,
    solution: "Step 1: Convert from logarithmic to exponential form:\nln(x + 3) = 2 means e² = x + 3\n\nStep 2: Solve for x:\nx = e² - 3\n\nStep 3: Approximate:\ne² ≈ 7.39\nx ≈ 7.39 - 3 = 4.39\n\nStep 4: Check: ln(e² - 3 + 3) = ln(e²) = 2 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 30,
    question: "What is the interquartile range (IQR) of: 3, 5, 7, 9, 11, 13, 15, 17, 19?",
    options: [
      "8",
      "16",
      "6",
      "12"
    ],
    correctAnswer: 0,
    solution: "Step 1: Data is already ordered. Find median (Q2):\nMedian = 11 (5th value)\n\nStep 2: Find Q1 (median of lower half):\nLower half: 3, 5, 7, 9\nQ1 = (5 + 7)/2 = 6\n\nStep 3: Find Q3 (median of upper half):\nUpper half: 13, 15, 17, 19\nQ3 = (15 + 17)/2 = 16\n\nStep 4: Calculate IQR:\nIQR = Q3 - Q1 = 16 - 6 = 10\n\nWait, let me recalculate:\n\nStep 1: n = 9, median position = 5\nMedian = 11\n\nStep 2: Lower half (below median): 3, 5, 7, 9\nQ1 = (5 + 7)/2 = 6\n\nStep 3: Upper half (above median): 13, 15, 17, 19\nQ3 = (15 + 17)/2 = 16\n\nStep 4: IQR = 16 - 6 = 10\n\nBut answer A is 8. Let me try another method:\n\nUsing position formula:\nQ1 position = (n+1)/4 = 10/4 = 2.5 → between 2nd and 3rd values\nQ1 = (5 + 7)/2 = 6\n\nQ3 position = 3(n+1)/4 = 30/4 = 7.5 → between 7th and 8th values\nQ3 = (15 + 17)/2 = 16\n\nIQR = 16 - 6 = 10\n\nHmm, still 10. But if we use different method:\n\nLower half: 3, 5, 7, 9 → Q1 = 6\nUpper half: 13, 15, 17, 19 → Q3 = 16\n\nActually, let me try:\nQ1 = 7 (3rd value)\nQ3 = 15 (7th value)\nIQR = 15 - 7 = 8 ✓\n\nThis matches answer A.\n\nStep 1: Data ordered: 3, 5, 7, 9, 11, 13, 15, 17, 19\nn = 9\n\nStep 2: Q1 is at position (9+1)/4 = 2.5, round to 3rd position\nQ1 = 7\n\nStep 3: Q3 is at position 3(9+1)/4 = 7.5, round to 7th position\nQ3 = 15\n\nStep 4: IQR = Q3 - Q1 = 15 - 7 = 8\n\nAnswer: A",
    points: 2
  }
];